import { fetchBlogFeed } from "@/features/home/api/blogFeed";
import { useQuery } from "@tanstack/react-query";

export const blogFeedQueryKey = ["blog-feed"] as const;

export const useBlogFeed = () =>
  useQuery({
    queryKey: blogFeedQueryKey,
    queryFn: fetchBlogFeed,
    staleTime: 5 * 60_000,
  });
